import React, { useContext } from 'react'

import notifier from 'tools/Notify'
import { LabeledRadioButtons } from 'tools/Uniform'
import { freeze } from 'utils/dom'

import GlobalContext from 'reducer/global'

import OrgContext from '../reducer'

const OPTIONS = freeze([
  { value: 'self', label: 'Self Managed' },
  { value: 'managed', label: 'Cato Managed' }
])

function OrgClass() {
  const [{ user }] = useContext(GlobalContext)
  const [{ name, onSave, ...org }] = useContext(OrgContext)
  const [, notifyD] = useContext(notifier.Context)
  const hasRoles = user.roles.size > 0

  const change = (value) => {
    onSave(
      { component: 'org', token: 'class' },
      value,
      notifier.saved.bind(null, notifyD),
      notifier.onCatch(notifyD)
    )
  }

  if (!hasRoles) return null

  return (
    <LabeledRadioButtons options={OPTIONS} active={org.class} onChange={change} />
  )
}

export default OrgClass
